import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Auth } from '@angular/fire/auth';
import { BaseService } from '../shared/base.service';
import { KnownUser } from '../user/known-user.model';

@Injectable({
    providedIn: 'root'
})

export class UserAccountService extends BaseService {

    public getUserAccount(idToken: string) {
        const headers = this.getHeaders(idToken);
        return this.httpClient.get(`${this.backendDomain}/user-account`, { headers });
    }

    public updateUserAccount(idToken: string, userType: string, userAccount: KnownUser) {
        //const body = JSON.stringify(userAccount);
        // Copy (slice) the returned stringifyExclude to avoid
        // permanently updating the source stringifyExclude.
        const stringifyExclude: string[] = userAccount.getStringifyExclude().slice();
        stringifyExclude.push("_user_roles");
        const body = userAccount.toJSON(stringifyExclude);
        const headers = this.getHeaders(idToken);
        return this.httpClient.put(`${this.backendDomain}/user-account/${userType}`, body, { headers });
    }
}
